import { useAxios } from '../../hooks/useAxios';

export const useRewardfulService = () => {
    const { get, post, isLoading } = useAxios();

    async function fetchAffiliateToken(compandyId) {
        return await get(`rewardful/affiliate/token/?company_id=${compandyId}`);
    }

    async function createAffiliateToken(data) {
        return await post('rewardful/affiliate/', data);
    }

    return {
        isLoading,
        fetchAffiliateToken,
        createAffiliateToken,
    };
};
